import { useMutation as u, useQueryClient as t } from "@tanstack/react-query";
import c from "./auth.api.js";
import { httpClient as g } from "../../httpClient.js";
import { teachurKeys as m } from "../../constants/teachurKeys.js";
const f = (e) => {
  const r = t();
  return u({
    mutationFn: async (a) => (await c.login(a)).data,
    onSuccess: (a, ...s) => {
      var n;
      r.setQueryData(m.users.currentUser(), a.user), (n = e == null ? void 0 : e.onSuccess) == null || n.call(e, a, ...s);
    },
    onError: (a, ...s) => {
      var n;
      (n = e == null ? void 0 : e.onError) == null || n.call(e, a, ...s);
    },
    meta: {
      successMessage: "Login successful",
      errorMessage: "Login failed. Please check your credentials and try again."
    },
    ...e
  });
}, w = (e) => u({
  mutationFn: async (r) => (await c.signup(r)).data,
  onSuccess: (r, ...a) => {
    var s;
    (s = e == null ? void 0 : e.onSuccess) == null || s.call(e, r, ...a);
  },
  onError: (r, ...a) => {
    var s;
    (s = e == null ? void 0 : e.onError) == null || s.call(e, r, ...a);
  },
  meta: {
    successMessage: "Check your email for account confirmation",
    errorMessage: "Signup failed"
  },
  ...e
}), S = (e) => u({
  mutationFn: async (r) => (await c.forgotPassword(r)).data,
  onSuccess: (r, ...a) => {
    var s;
    (s = e == null ? void 0 : e.onSuccess) == null || s.call(e, r, ...a);
  },
  onError: (r, ...a) => {
    var s;
    (s = e == null ? void 0 : e.onError) == null || s.call(e, r, ...a);
  },
  meta: {
    successMessage: (r) => r.message,
    errorMessage: "Password reset failed. Please try again."
  },
  ...e
}), h = (e) => u({
  mutationFn: async (r) => (await c.resetPassword(r)).data,
  onSuccess: (r, ...a) => {
    var s;
    (s = e == null ? void 0 : e.onSuccess) == null || s.call(e, r, ...a);
  },
  onError: (r, ...a) => {
    var s;
    (s = e == null ? void 0 : e.onError) == null || s.call(e, r, ...a);
  },
  meta: {
    successMessage: (r) => r.message,
    errorMessage: "Failed to send password reset email. Please try again."
  },
  ...e
}), k = (e) => {
  const r = t();
  return u({
    mutationFn: async () => {
      await c.logout();
    },
    onSuccess: () => {
      g.setAuthToken(null), r.clear();
    },
    meta: {
      successMessage: "Logout successful",
      errorMessage: "Logout failed"
    },
    ...e
  });
}, F = (e) => {
  const r = t();
  return u({
    mutationFn: async () => (await c.refreshToken()).data,
    onSuccess: (a) => {
      g.setAuthToken(a.accessToken), r.setQueryData(m.users.currentUser(), a.user);
    },
    meta: {
      successMessage: "Token refreshed",
      errorMessage: "Failed to refresh token"
    },
    ...e
  });
};
export {
  S as useForgotPasswordMutation,
  f as useLoginMutation,
  k as useLogoutMutation,
  F as useRefreshTokenMutation,
  h as useResetPasswordMutation,
  w as useSignupMutation
};
